import { render, staticRenderFns } from "./PoveznicaDataCreate.vue?vue&type=template&id=6efdda56&scoped=true&"
import script from "./PoveznicaDataCreate.vue?vue&type=script&lang=js&"
export * from "./PoveznicaDataCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efdda56",
  null
  
)

export default component.exports